/**
 * Obtiene el token de autenticación del localStorage y construye el objeto de headers de Axios.
 * @returns {Object} Objeto de headers con la propiedad Authorization.
 * @throws {Error} Si el token no se encuentra.
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem("userToken");

  if (!token) {
    // Lanza un error para ser capturado en el try/catch del componente.
    throw new Error(
      "Token de autenticación no encontrado. Por favor, inicia sesión."
    );
  }

  return token;
};
